
















































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  SetupContext
} from "@vue/composition-api";

import boxLinkSvg from "@/assets/svg/boxLink.svg";

import CompanyKey from "@/components/company-key";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const companyStore = inject(CompanyKey);
    if (!companyStore) {
      throw new Error(`${CompanyKey} is not provided`);
    }

    onMounted(() => {
      companyStore.clearCompanyAddParams();
    });

    const agree = () => {
      context.root.$router.push({ name: "CompanyAddInput" });
    };

    const back = () => {
      context.root.$router.push({ name: "MemberPersonal" });
    };

    return {
      agree,
      back
    };
  },
  components: {
    boxLinkSvg
  }
});
